import { Link } from "react-router-dom";
import { localePath, type LandingLocale } from "@/lib/landing/locale";
import { splitLegalLinks } from "@/lib/legal/links";

const linkClass =
  "font-medium text-[hsl(var(--action))] underline-offset-2 hover:underline dark:text-primary";

/**
 * Legal copy with `[label](href)` links rendered as real links, resolved for
 * the page's language (from its URL) and host, like every public-page link.
 */
export function LegalText({ text, locale }: { text: string; locale: LandingLocale }) {
  return (
    <>
      {splitLegalLinks(text).map((part, i) => {
        if (part.kind === "text") return <span key={i}>{part.text}</span>;
        // A router link would not scroll to "#cenik", so anchors on another
        // page get a full navigation instead.
        if (part.internal && !part.href.includes("#")) {
          return (
            <Link key={i} to={localePath(locale, part.href)} className={linkClass}>
              {part.label}
            </Link>
          );
        }
        const href = part.internal ? localePath(locale, part.href) : part.href;
        return (
          <a key={i} href={href} className={linkClass}>
            {part.label}
          </a>
        );
      })}
    </>
  );
}
